import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=f7b6da34&scoped=true&"
import script from "./ChatBot.vue?vue&type=script&lang=js&"
export * from "./ChatBot.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=f7b6da34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b6da34",
  null
  
)

export default component.exports